import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import GonkBoundary from "views/GonkBoundary";

class DrawerLayoutJS extends React.Component {
    constructor(props) {
        super(props);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onClick = this.onClick.bind(this);
        this.bodyContentRef = React.createRef();
        this.state = {
            height: null
        };
    }

    onKeyDown(e) {
        if(["Enter", " "].includes(e.key)) {
            e.preventDefault();
            this.onClick(e);
        }
    }

    onClick(e) {
        const {enabled, onDrawerToggle, open} = this.props;
        if (!enabled) return;
        onDrawerToggle(e, open);
    }

    componentDidMount() {
        this.updateBodyHeight();
    }

    componentDidUpdate() {
        this.updateBodyHeight();
    }

    updateBodyHeight() {
        this.setState(s => {
            const bodyContentElm = this.bodyContentRef.current;
            if (bodyContentElm == null) return;
            let height = bodyContentElm.clientHeight;
            if(s.height === null && height === 0) {
                // weird case when content first renders open and the clientHeight
                // is initially 0.
                height = null;
            }
            if (s.height === height) return;
            return { height };
        });
    }

    render() {
        const {enabled, open, drawerContent, content} = this.props;
        const drawerClasses = classNames("drawer-container", {
            "disabled": !enabled,
            "enabled": enabled,
            "open": open,
        });
        return (
            <React.Fragment>
                <div className={drawerClasses} style={{top: open ? 0 : -this.state.height}}>
                    <div className="drawer-body" style={{height: open ? null : this.state.height}}>
                        <GonkBoundary>
                            <div ref={this.bodyContentRef}>
                                {drawerContent}
                            </div>
                        </GonkBoundary>
                    </div>
                    <div className="drawer-pull" onClick={this.onClick} onKeyDown={this.onKeyDown}>
                        <div className="drawer-tab">
                            <a className="btn btn-drawer-pull">
                                <span className="glyphicon glyphicon-search" />
                                <span className="glyphicon glyphicon-chevron-down" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="drawer-content">
                    <GonkBoundary>
                        {content}
                    </GonkBoundary>
                </div>
            </React.Fragment>
        );
    }
}

DrawerLayoutJS.propTypes = {
    enabled: PropTypes.bool.isRequired,
    open: PropTypes.bool.isRequired,
    onDrawerToggle: PropTypes.func.isRequired,
    drawerContent: PropTypes.node,
    content: PropTypes.node
};

export default DrawerLayoutJS;



// WEBPACK FOOTER //
// ./app/lib/common/drawer/DrawerLayoutJS.js